module.exports = __webpack_public_path__ + "static/media/HPP_Opportunity_Icon.b7c5ffb8.svg";